import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type LinkButtonSize = 'sm' | 'md' | 'lg'

export type LinkButtonPreviewState =
  | 'default'
  | 'hover'
  | 'pressed'
  | 'focused'
  | 'disabled'

export const LINK_BUTTON_SIZES: LinkButtonSize[] = ['sm', 'md', 'lg']

export const LINK_BUTTON_PREVIEW_STATES: LinkButtonPreviewState[] = [
  'default',
  'hover',
  'pressed',
  'focused',
  'disabled',
]

export const LINK_BUTTON_SIZE_LABELS: Record<LinkButtonSize, string> = {
  sm: 'S',
  md: 'M',
  lg: 'L',
}

export const LINK_BUTTON_PREVIEW_STATE_LABELS: Record<
  LinkButtonPreviewState,
  string
> = {
  default: 'Default',
  hover: 'Hover',
  pressed: 'Pressed',
  focused: 'Focused',
  disabled: 'Disabled',
}

export type LinkButtonProps = {
  children?: ReactNode
  label?: string
  size?: LinkButtonSize
  underline?: boolean
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  className?: string
  /** Dark surface styling. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: LinkButtonPreviewState
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>
